// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"f2801189","84":"d20ef951","247":"23c123bf","440":"aaad89cd","453":"070bb51f","627":"861a8484","738":"57c5f0c3","834":"a327cdac","923":"15194a5a","938":"f86a5339"}[chunkId] + ".chunk.js";
};